import { useState } from 'react';

import { useGoToActiveCompetition } from '@/competitions/_common/hooks/useGoToActiveCompetition.ts';
import { getRegisterSourceData } from '@/lib/analytics/registerSource.ts';
import { sendUserPortalEvent } from '@/lib/analytics/unified.ts';
import type { CompetitionWithConfig } from '@/lib/api/requests.ts';
import { Button } from '@/ui/button-2.tsx';

import useBrainSession from '../../../../../../services/BrainSession/useBrainSession.ts';
import { CardDialog } from '../../../chat-answers/_common/card-dialog.tsx';

import { useHasEnded } from './use-has-ended.ts';

export const CTA = (props: {
  className?: string;
  onClick?: () => void;
  activeCompetition: CompetitionWithConfig | undefined;
  displayWarningWhenKIn: string[] | undefined;
}) => {
  const { toggleChat } = useBrainSession();
  const ended = useHasEnded();
  const goToActiveCompetition = useGoToActiveCompetition(props.activeCompetition);
  const checkShouldAsk = () => {
    if (!props.displayWarningWhenKIn) {
      return false;
    }
    return props.displayWarningWhenKIn.includes(getRegisterSourceData().params.k);
  };
  const [isOpen, setIsOpen] = useState(false);

  if (ended) {
    return (
      <Button
        color="orange"
        className={props.className}
        onClick={() => {
          props.onClick?.();
          void goToActiveCompetition();
        }}
      >
        Se den nye trekningen
      </Button>
    );
  }

  return (
    <>
      <Button
        color="orange"
        className={props.className}
        onClick={() => {
          props.onClick?.();
          if (checkShouldAsk()) {
            sendUserPortalEvent('jul26_conditions_notice_displayed');
            setIsOpen(true);
            return;
          }
          toggleChat({
            goal: 'july_2026_campaign',
            step: 'init',
          });
        }}
      >
        Søk og delta
      </Button>

      <CardDialog.Root open={isOpen} onOpenChange={setIsOpen}>
        <CardDialog.Content>
          <CardDialog.Card>
            <CardDialog.Title className="mb-2 typography-v1-h3">
              Har du rentebærende forbruks- eller kredittkortgjeld?
            </CardDialog.Title>

            <p className="mb-6 typography-v1-body3">
              For å delta i konkurransen må man søke om lavere rente på eksisterende forbruks- og
              kredittkortgjeld.
            </p>

            <div className="flex flex-col gap-4">
              <Button
                color="orange"
                onClick={() => {
                  setIsOpen(false);
                  sendUserPortalEvent('jul26_conditions_notice_submitted');
                  toggleChat({
                    goal: 'july_2026_campaign',
                    step: 'init',
                  });
                }}
              >
                Ja, jeg har det. Fortsett
              </Button>
              <Button
                color="white"
                onClick={() => {
                  sendUserPortalEvent('jul26_conditions_notice_closed');
                  setIsOpen(false);
                }}
              >
                Lukk
              </Button>
            </div>
          </CardDialog.Card>
        </CardDialog.Content>
      </CardDialog.Root>
    </>
  );
};
